export const GROUP_OPEN_CREATE_MODAL = "GROUP_OPEN_CREATE_MODAL";
export const GROUP_DETAIL_ARCHIVE = "GROUP_DETAIL_ARCHIVE";
export const GROUP_DETAIL_EDIT = "GROUP_DETAIL_EDIT";
